import React from "react";
import { CodeIcon } from "@heroicons/react/solid";
import { project_data } from "../data";






export default function Projects(){

    return(
        <section id = "projects" className = "text-gray-400 bg-gray-900 body-font">
            <div className = "container px-5 py-10 mx-auto text-center lg:px-40">
                <div className = "container px-5 py-10 mx-auto text-center" >
                    <CodeIcon className = "mx-auto inline-block w-10 mb-4"/>
                    <h1 className = "sm:text-4xl text-3xl font-medium title-font mb-4 text-white">
                        Projects
                    </h1>
                    <p className = "lg:w-2/3 mx-auto leading-relaxed text-base">
                        Projects I have worked along with my amazing collaborators
                    </p>
                </div>






                <div className = "flex flex-wrap -m-4">
                    {project_data.map((project) => (
                        <a
                            href = {project.link}
                            key = {project.image}
                            className = "sm:w-1/2 w-100 p-4">
                            <div className = "flex relative">
                                <img
                                alt = "gallery"
                                className = "absolute inset-0 w-full h-full object-contain object-center"
                                src = {project.image}                                
                                />
                                <div className = "px-8 py-10 relative z-10 w-full border-4 border-gray-800 bg-gray-900 opacity-0 hover:opacity-90">
                                    <h2 className = "tracking-widest text-sm title-font font-medium text-green-400 mb-1"> {/* tracking controls letter spacing */}
                                        {project.subtitle}
                                    </h2>
                                    <h1 className = "title-font text-lg font-medium text-white mb-3">
                                        {project.title}
                                    </h1>
                                    <p className = "leading-relaxed">
                                        {project.description}
                                    </p>
                                </div>
                            </div>
                        </a>
                    ))}
                </div>
            </div>

        </section>
    )
}